<template>
  <Modal title="Поразмерное количество продукта" @backdrop-click="saveValues">
    <template slot="body">
      <div>
        <div class="table-responsive table-responsive_long-list vert-scroll">
          <table class="table table__body_product-sizes">
            <thead>
              <tr>
                <th class="list__column">Межд.размер</th>
                <th class="list__column">Рос.размер</th>
                <th class="list__column">Пол</th>
                <th class="list__column">Количество</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="size in list" :key="size.id">
                <td class="list__row">
                  {{ size.international_version }}
                </td>
                <td class="list__row">
                  {{ size.russian_version }}
                </td>
                <td class="list__row">
                  {{ size.gender }}
                </td>
                <td v-if="readonly" class="list__row">
                  {{ size.count }}
                </td>
                <td v-else class="list__row">
                  <Counter
                    :item="size"
                    @change="valuesWereChanged = true"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>
    <template slot="footer">
      <div>
        <button
          type="button"
          class="btn"
          :class="buttonCss"
          @click="saveValues"
        >
          <span v-if="readonly">
            Выйти
          </span>
          <span v-else>
            <i class="fa fa-fw fa-check" />
            Сохранить
          </span>
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/_shared/components/ui/Modal';
import Counter from '@/_shared/components/ui/Counter';
export default {
  emits: ['close'],
  components: {
    Modal,
    Counter,
  },
  props: {
    list: {
      type: Array,
      default() {
        return null;
      },
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valuesWereChanged: false,
    };
  },
  mounted() {
    document.querySelector('body').style.overflow = 'hidden';
  },
  computed: {
    buttonCss() {
      const modifier = this.readonly ? 'primary' : 'success';
      return [`btn-${modifier}`];
    },
  },
  methods: {
    saveValues() {
      document.querySelector('body').style.overflow = 'auto';
      this.$emit("close", this.valuesWereChanged);
    },
  },
};
</script>

<style scoped>
.table__body_product-sizes > tbody > tr > td {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/stock/widgets/project/ProductSizesModal.vue